import type { GetServerSideProps } from 'next'
import { RecommendPage } from '@features/recommend/pages/RecommendPage'
import { AppLayout } from '@components/layouts/AppLayout'
import { OgShare } from '@components/OgShare'
import { BASE_URL } from '@configs/config'
import { maintenanceHandler } from '@lib/maintenanceHandler'

function Recommend({ url }: { url: string }) {
  return (
    <AppLayout>
      <OgShare url={url} />
      <RecommendPage />
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return maintenanceHandler({
    url: `${BASE_URL}${req.url}`,
  })
}

export default Recommend
